





























































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
import NoteModal from '../../components/note-modal.vue'
import CreateModal from './create-invoice-seq.vue'
class  PageInvoiceSeqRequest extends PageRequest{
    keyword:string;
    status: string;
    clientCode: string;
    from:Date;
    to:Date;
}
@Component({
    components: {'note-modal':NoteModal,'create-invoice-seq':CreateModal }
})
export default class InvoiceSeq extends mixins(ListMixin, AbpBase){
    namespace = 'invoiceSeq';
    creationTime:Date[]=[];
    pagerequest:PageInvoiceSeqRequest=new PageInvoiceSeqRequest();
    spinShow:boolean=false;
    statuses = [];
    clients=[];
    cancelNote :string="";
    noteModalShow:boolean=false;
    createModalShow:boolean=false;

     get store () {
      return this.$store.state.invoiceSeq;
    }
    isTenant() {
      return this.$store.state.session.tenant != null;
    }
    async getStatuses(){
        await this.$store.dispatch({
            type:'invoiceSeq/getStatusesForSelect',
             data: { hasAllItem: true}
        }).then(()=>{
          var re = this.$store.state.invoiceSeq.statuses;
          this.$set(this.pagerequest, 'status', re.length === 0 ? "" : re[0].code);
          this.statuses = re;
        });
    }
    async getClients(){
         await this.$store.dispatch({
          type:'client/getListForSelect',
          data:{ hasAllItem: true}
      })
      .then(() => {
          this.clients = this.$store.state.client.clientsForSelect;
          this.$set(this.pagerequest, 'clientCode', this.clients.length === 0 ? "" : this.clients[0].code);
      });
       
    }
    buildPageRequest()
    {
        if (this.creationTime.length>0) {
            this.pagerequest.from=this.creationTime[0];
        }
        if (this.creationTime.length>1) {
            this.pagerequest.to=this.creationTime[1];
        }
    }
    async exportToExcel () {
      this.buildPageRequest();
      await this.$store.dispatch({
        type: "report/exportInvoiceSeq",
        data: this.pagerequest
      });
    }
    createInvoiceSeq()
    {
        this.createModalShow=true;
    }
     openCancelNoteModal()
    {
        this.cancelNote="";
        this.noteModalShow = true;
    }
    cancelInvoiceSeq()
    {
        if(Util.isEmpty(this.cancelNote))
        {
           return; 
        }
        this.$Modal.confirm({
            title:this.L('Tips'),
            content:this.L('Confirm.CancelInvoiceSeq'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk:async()=>{
                this.spinShow=true;
                try {
                   await this.$store.dispatch({
                    type:this.namespace+'/cancel',
                    data:{
                      clientCode: this.pagerequest.clientCode,
                      note: this.cancelNote
                    }
                  }).then(async esult => {
                        Util.showSuccessMsg(this,"Success.CancelInvoiceSeq");
                        this.cancelNote="";
                        this.getpage();
                  });
                  this.spinShow = false;
                } catch (error) {
                  this.spinShow = false;
                }
            }
        })
    }
    get list(){
      var re = this.store.list;
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var index = 0;
      re.forEach(function(item) {
        item.orderNo = startIndex + index + 1;
        index++;
      });
      return re;
    }
    preGetPage () {
        this.buildPageRequest();
    }
    columns= [
      {
          title:Util.L('Order'),
          key:'orderNo',
          width: 80,
        },
         {
            title:Util.L('Client'),
            key:'clientName'
        },
         {
            title:Util.L('Code'),
            key:'invoiceCode'
        },
         {
            title:Util.L('InvoiceNo'),
            key:'invoiceNo'
        },
         {
            title:Util.L('SoCode'),
            key:'soCode'
        },{
            title:Util.L('ExternalPoCode'),
            key:'externalCode'
        },{
            title:Util.L('Status'),
            key:'statusText'
        },{
            title:Util.L('CreationTime'),
            key:'creationTime',
            render:(h:any,params:any)=>{
                return h("span", Util.toViewDateString(params.row.creationTime));
            }
        }
    ]
    async created(){
      this.spinShow= true;
      try {
         await this.getClients();
        await this.getStatuses();
        var defaultDate = new Date();
        this.creationTime = [defaultDate,defaultDate];
        this.spinShow = false;
      } catch (error) {
        this.spinShow=false;
      }
       
    }
}
